// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region vars
    name: 'g-simple-layout',
    // #endregion
    // #region Props
    // #region Data
    props: {
        showImage: {
            type: Object,
            required: false,
            default: {}
        },
    },
    // #endregion
    //#endregion       
});
// #endregion
